<app-feed-help *ngIf="mode === 'dialog'" text="Direitos Autorais"></app-feed-help>

<p-tabView class="tabViewEmbbeding" [activeIndex]="activeTabIndex">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>Solicitar direitos</span>
        </ng-template>
        <div class="mt-4">
            <account-selector source="instagram" [autoload]="false" [showLabel]="true"
                [selectedAccountId]="selectedInstagramAccountId"
                (instagramAccountSelected)="onInstagramAccountSelecionada($event)"
                (accountsLoaded)="onAccountsCarregadas($event)">
            </account-selector>
        </div>

        <div class="mt-3 mb-3">
            <label class="block text-sm font-medium text-900 mb-2">Palavra-chave de confirmação</label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">#</span>
                <input pInputText [(ngModel)]="urKeyWord" placeholder="palavrachave" class="w-full"
                    [disabled]="isLocked" (ngModelChange)="onKeywordChange()">
            </div>
            <small *ngIf="urKeyWord.length > 0 && !urKeyWordValida" class="p-error">
                A palavra-chave deve ter pelo menos 3 caracteres.
            </small>
        </div>

        <!-- Seção 1: Enviar comentário automático -->
        <div class="card mb-2 shadow-none border-1"
            [ngClass]="contaMencionada ? 'border-primary' : 'surface-border opacity-60'">
            <div class="flex align-items-center gap-2 cursor-pointer" [class.mb-3]="!direitosCollapsed.auto"
                (click)="toggleDireitos('auto')" pRipple>
                <i class="pi pi-send text-primary" style="font-size: 1.2rem;"></i>
                <div class="flex-1">
                    <div class="font-bold text-base">Enviar comentário automaticamente</div>
                    <div class="text-sm text-600">
                        {{ contaMencionada ? 'Sua conta foi mencionada neste post' : 'Sua conta não foi mencionada neste
                        post' }}
                    </div>
                </div>
                <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                    [ngClass]="{ 'rotate-180': !direitosCollapsed.auto }"></i>
            </div>
            <div class="collapsible" [class.collapsed]="direitosCollapsed.auto">
                <div class="collapsible__inner">
                    <div class="mb-3">
                        <p class="m-0 text-sm text-700 mb-2">Escreva o comentário que será postado automaticamente no
                            Instagram. A mensagem deve conter <strong>@{{ selectedInstagramHandle || 'handle'
                                }}</strong> e uma <strong>#palavrachave</strong>:</p>
                        <textarea #taAuto pInputTextarea [(ngModel)]="mensagemDireitos" rows="5"
                            class="w-full text-sm w-full p-inputtextarea p-inputtext" style="resize: vertical;"
                            (keydown)="onTextareaKeydown($event, taAuto)" (input)="onTextareaInput(taAuto)"></textarea>
                        <small *ngIf="mensagemDireitos.trim() && !mensagemValida" class="p-error">
                            A mensagem deve conter @{{ selectedInstagramHandle || 'handle' }} e #{{ urKeyWord ||
                            'palavrachave' }} (mín. 3 caracteres).
                        </small>
                    </div>
                    <button pButton type="button"
                        [label]="alreadySentDireitos ? 'Enviar novamente' : 'Salvar e Enviar comentário'"
                        [icon]="displayAguardeComment ? 'pi pi-spin pi-spinner' : 'pi pi-send'" class="w-full"
                        [disabled]="!mensagemValida || displayAguardeComment" (click)="salvarEEnviarDireitos()">
                    </button>
                </div>
            </div>
        </div>

        <!-- Seção 2: Enviar manualmente -->
        <div class="card mb-0 shadow-none border-1 border-primary">
            <div class="flex align-items-center gap-2 cursor-pointer" [class.mb-3]="!direitosCollapsed.manual"
                (click)="toggleDireitos('manual')" pRipple>
                <i class="pi pi-user-edit text-primary" style="font-size: 1.2rem;"></i>
                <div class="flex-1">
                    <div class="font-bold text-base">Enviar manualmente</div>
                    <div class="text-sm text-600">Poste o comentário você mesmo no Instagram</div>
                </div>
                <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                    [ngClass]="{ 'rotate-180': !direitosCollapsed.manual }"></i>
            </div>
            <div class="collapsible" [class.collapsed]="direitosCollapsed.manual">
                <div class="collapsible__inner">
                    <div class="mb-3">
                        <p class="m-0 text-sm text-700 mb-2">Acesse o post no Instagram e publique
                            <strong>manualmente</strong> o comentário abaixo. A mensagem deve conter <strong>@{{
                                selectedInstagramHandle || 'handle' }}</strong> e uma <strong>#palavrachave</strong>:
                        </p>
                        <textarea #taManual pInputTextarea [(ngModel)]="mensagemDireitos" rows="5"
                            class="w-full text-sm w-full p-inputtextarea p-inputtext" style="resize: vertical;"
                            (keydown)="onTextareaKeydown($event, taManual)"
                            (input)="onTextareaInput(taManual)"></textarea>
                        <small *ngIf="mensagemDireitos.trim() && !mensagemValida" class="p-error">
                            A mensagem deve conter @{{ selectedInstagramHandle || 'handle' }} e #{{ urKeyWord ||
                            'palavrachave' }} (mín. 3 caracteres).
                        </small>
                        <p class="mt-2 m-0 text-xs text-500">Quando o criador responder com a palavra-chave, os direitos
                            serão registrados automaticamente.</p>
                    </div>
                    <button pButton type="button" label="Copiar e Salvar"
                        [icon]="displayAguardeComment ? 'pi pi-spin pi-spinner' : 'pi pi-copy'"
                        class="w-full p-button-outlined" [disabled]="!mensagemValida || displayAguardeComment"
                        (click)="salvarKeyWordDireitos()">
                    </button>
                </div>
            </div>
        </div>

    </p-tabPanel>

    <p-tabPanel *ngIf="showComentarioEnviadoTab">
        <ng-template pTemplate="header">
            <span>Comentários enviados</span>
        </ng-template>
        <div *ngFor="let envio of sentComments; let first = first" class="mb-4 mt-4">
            <div class="flex gap-2">
                <img [src]="envio.avatar || 'assets/layout/images/avatar.png'" class="border-circle flex-shrink-0"
                    style="width: 2rem; height: 2rem; object-fit: cover;">
                <div class="flex-1 min-w-0">
                    <div class="flex align-items-center gap-1 flex-wrap">
                        <span class="text-sm font-medium text-900">{{ envio.handle || selectedInstagramHandle }}</span>
                        <i *ngIf="first" class="pi pi-check-circle text-blue-500 text-xs" pTooltip="Envio mais recente"
                            [appendTo]="'body'"></i>
                        <span class="text-xs text-500">· {{ envio.sent_at | ssTimeago }}</span>
                    </div>
                    <div class="text-sm white-space-pre-line mt-1">{{ liveTextByCommentId[envio.comment_id] ?? envio.message ?? sentCommentValue }}</div>
                    <div class="flex align-items-center gap-3 mt-1">
                        <span *ngIf="repliesByCommentId[envio.comment_id]?.length" class="text-xs text-500 font-medium cursor-pointer"
                            (click)="toggleReply(envio.comment_id)">
                            {{ showReplyFor === envio.comment_id ? 'Ocultar respostas' : 'Ver respostas (' + repliesByCommentId[envio.comment_id].length + ')' }}
                        </span>
                        <span *ngIf="isOwnMediaFor(envio.handle)"
                            class="text-xs text-red-500 font-medium cursor-pointer"
                            [ngClass]="{ 'opacity-50 pointer-events-none': excluindoComentario }"
                            (click)="excluirComentarioEnviado(envio.comment_id)">
                            Excluir
                        </span>
                    </div>

                    <div *ngIf="showReplyFor === envio.comment_id" class="mt-3">
                        <div *ngFor="let reply of repliesByCommentId[envio.comment_id]"
                            class="flex gap-2 pl-3 mb-2 border-left-2 surface-border">
                            <img [src]="replyAuthorAvatarFor(reply.from?.username) || 'assets/layout/images/avatar.png'"
                                class="border-circle flex-shrink-0" style="width: 1.75rem; height: 1.75rem; object-fit: cover;">
                            <div class="flex-1 min-w-0">
                                <div class="flex align-items-center gap-1 flex-wrap">
                                    <span class="text-sm font-medium text-900">{{ reply.from?.username || replyAuthorName }}</span>
                                    <i *ngIf="replyApproved && reply.id === approvedReplyId" class="pi pi-check-circle text-green-500 text-xs"
                                        pTooltip="Aprovado" [appendTo]="'body'"></i>
                                    <span class="text-xs text-500">· {{ reply.timestamp | ssTimeago }}</span>
                                </div>
                                <div class="text-sm white-space-pre-line mt-1">{{ reply.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isOwnMediaFor(sentComments[0]?.handle)" class="text-xs text-500 mt-3">
            <i class="pi pi-info-circle mr-1"></i>Via Graph API não é possível excluir um comentário postado em um post
            que não é da própria conta conectada.
        </div>
    </p-tabPanel>
</p-tabView>